import { MessageCircle, Mail, Activity, ExternalLink } from 'lucide-react';

// Status page is a separate single-page site (no react-router) so internal
// links go to www.androhost.com as hard URLs. Layout matches the marketing
// site's Footer.tsx so customers see one consistent shell across surfaces.

const WWW = 'https://www.androhost.com';

export default function Footer() {
  return (
    <footer className="mt-20 border-t border-teal/10">
      <div className="container py-14">

        {/* Top: four equal columns */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-x-8 gap-y-10">

          {/* Product */}
          <div>
            <h4 className="display text-xs tracking-widest text-offwhite/55 mb-4 uppercase">Product</h4>
            <ul className="space-y-2.5 text-sm">
              <li><a href={`${WWW}/#games`} className="text-offwhite/75 hover:text-teal transition-colors">Games</a></li>
              <li><a href={`${WWW}/#pricing`} className="text-offwhite/75 hover:text-teal transition-colors">Pricing</a></li>
              <li><a href={`${WWW}/#free-tier`} className="text-offwhite/75 hover:text-teal transition-colors">Free tier</a></li>
              <li>
                <a href="https://panel.androhost.com" target="_blank" rel="noopener noreferrer" className="text-offwhite/75 hover:text-teal transition-colors inline-flex items-center gap-1">
                  Game Panel <ExternalLink className="w-3 h-3" />
                </a>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h4 className="display text-xs tracking-widest text-offwhite/55 mb-4 uppercase">Resources</h4>
            <ul className="space-y-2.5 text-sm">
              <li><a href={`${WWW}/blog`} className="text-offwhite/75 hover:text-teal transition-colors">Blog</a></li>
              <li><a href={`${WWW}/about`} className="text-offwhite/75 hover:text-teal transition-colors">About</a></li>
              <li>
                <a href="https://status.androhost.com" className="text-teal transition-colors inline-flex items-center gap-1">
                  <Activity className="w-3.5 h-3.5" /> Status
                </a>
              </li>
            </ul>
          </div>

          {/* Community */}
          <div>
            <h4 className="display text-xs tracking-widest text-offwhite/55 mb-4 uppercase">Community</h4>
            <ul className="space-y-2.5 text-sm">
              <li>
                <a href="https://discord.gg/9Y5zpKnfws" target="_blank" rel="noopener noreferrer" className="text-offwhite/75 hover:text-teal transition-colors inline-flex items-center gap-1.5">
                  <MessageCircle className="w-4 h-4 text-teal" /> Discord
                </a>
              </li>
              <li>
                <a href="mailto:support@androhost.com" className="text-offwhite/75 hover:text-teal transition-colors inline-flex items-center gap-1.5">
                  <Mail className="w-4 h-4 text-teal" /> support@androhost.com
                </a>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="display text-xs tracking-widest text-offwhite/55 mb-4 uppercase">Legal</h4>
            <ul className="space-y-2.5 text-sm">
              <li><a href={`${WWW}/privacy`} className="text-offwhite/75 hover:text-teal transition-colors">Privacy</a></li>
              <li><a href={`${WWW}/terms`} className="text-offwhite/75 hover:text-teal transition-colors">Terms</a></li>
              <li><a href={`${WWW}/refund`} className="text-offwhite/75 hover:text-teal transition-colors">Refunds</a></li>
              <li><a href={`${WWW}/acceptable-use`} className="text-offwhite/75 hover:text-teal transition-colors">Acceptable use</a></li>
            </ul>
          </div>
        </div>

        {/* Brand + tagline band */}
        <div className="mt-14 pt-10 border-t border-teal/10">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            <div className="flex items-center gap-3">
              <img src="/androhost-rocket.svg" alt="" className="h-10 w-auto" />
              <div>
                <div className="display text-lg tracking-wider text-offwhite leading-tight">
                  ANDRO<span className="text-red">HOST</span>
                </div>
                <div className="text-xs text-offwhite/55 leading-tight">Hosted from Long Island, NY</div>
              </div>
            </div>

            <div className="display text-2xl md:text-3xl tracking-widest text-center bg-gradient-to-r from-teal via-tealLight to-red bg-clip-text text-transparent">
              WHERE WORLDS TAKE FLIGHT
            </div>
          </div>

          <div className="mt-8 text-[11px] text-offwhite/35 text-center md:text-left">
            © 2026 Andromedacraft Hosting LLC. AndroHost is a service of Andromedacraft Hosting LLC.
          </div>
        </div>
      </div>
    </footer>
  );
}
